import React from 'react';
import {Trans} from 'react-i18next';
import Select from 'react-select';
import {deviceOptions} from '../../config/utils/optionsUtils';
import storeUtils from '../../../../../utils/storeUtils';
import _get from 'lodash/get';
import {Field, FieldArray} from 'formik';
import _isEmpty from 'lodash/isEmpty';
import DeviceImage from '../../landingpage/deviceImage';
import InputBox from '../../../../../components/formik/InputBox';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import ToggleEnableField from '../../../components/togglernablefield';
import useWindowWidth from '../../../../../components/hook/useWindowWidth';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../../utils/smbUtils';

export default function GenericLayoutSettings({
  formikProps,
  device,
  setDevice,
}) {
  const width = useWindowWidth();
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);
  return (
    <>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.landingpage.skin.main">Main</Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.landingpage.main.image">
          Main Image
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.landingpage.device">Device</Trans>
        </label>
        <div className="col-5">
          <Select
            options={deviceOptions}
            onChange={o => {
              storeUtils.setUiConfigSettingDevice(customerId, _get(o, 'value'));
              setDevice(o);
            }}
            value={device}
            isSearchable={false}
            isClearable={false}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.landingpage.main.image">
            Main Image
          </Trans>
        </label>
        <div className="col-4">
          {device.value === 'pad' && (
            <FieldArray name={`mainImage[0].imagesUrl`}>
              {arrayHelpers => (
                <div style={{display: 'flex'}}>
                  {!_isEmpty(
                    _get(formikProps.values, `mainImage[0].imagesUrl`)
                  ) &&
                    _get(formikProps.values, `mainImage[0].imagesUrl`).map(
                      (s, index) => (
                        <div
                          key={`padbanner${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {index !== 0 && (
                            <button
                              type="button"
                              className="btn-icon-only default"
                              style={{
                                width: '25px',
                                height: '25px',
                                color: '#666',
                              }}
                              key={'btn' + index}
                              onClick={() => {
                                arrayHelpers.swap(index - 1, index);
                              }}
                            >
                              <i className="fa fa-exchange-alt" />
                            </button>
                          )}
                          <Field
                            name={`mainImage[0].imagesUrl[${index}]`}
                            scaleImage={true}
                            clearFormFields={[
                              `mainImage[0].imagesUrl[${index}].image`,
                              `mainImage[0].imagesUrl[${index}].url`,
                            ]}
                            component={DeviceImage}
                            width={1536}
                            height={1468}
                            maxWidth={300}
                            maxHeight={(300 / 1536) * 1468}
                            values={formikProps.values}
                          />
                        </div>
                      )
                    )}
                </div>
              )}
            </FieldArray>
          )}
          {device.value === 'mobile' && (
            <FieldArray name={`mainImage[1].imagesUrl`}>
              {arrayHelpers => (
                <div style={{display: 'flex'}}>
                  {!_isEmpty(
                    _get(formikProps.values, `mainImage[1].imagesUrl`)
                  ) &&
                    _get(formikProps.values, `mainImage[1].imagesUrl`).map(
                      (s, index) => (
                        <div
                          key={`phonebanner${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {index !== 0 && (
                            <button
                              type="button"
                              className="btn-icon-only default"
                              style={{
                                width: '25px',
                                height: '25px',
                                color: '#666',
                              }}
                              key={'btn' + index}
                              onClick={() => {
                                arrayHelpers.swap(index - 1, index);
                              }}
                            >
                              <i className="fa fa-exchange-alt" />
                            </button>
                          )}
                          <Field
                            name={`mainImage[1].imagesUrl[${index}]`}
                            scaleImage={true}
                            clearFormFields={[
                              `mainImage[1].imagesUrl[${index}].image`,
                            ]}
                            component={DeviceImage}
                            width={750}
                            height={996}
                            maxWidth={300}
                            maxHeight={(300 / 750) * 996}
                            values={formikProps.values}
                          />
                        </div>
                      )
                    )}
                </div>
              )}
            </FieldArray>
          )}
          {device.value === 'padLandscape' && (
            <FieldArray name={`mainImage[2].imagesUrl`}>
              {arrayHelpers => (
                <div style={{display: 'flex'}}>
                  {!_isEmpty(
                    _get(formikProps.values, `mainImage[2].imagesUrl`)
                  ) &&
                    _get(formikProps.values, `mainImage[2].imagesUrl`).map(
                      (s, index) => (
                        <div
                          key={`phonebanner${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {index !== 0 && (
                            <button
                              type="button"
                              className="btn-icon-only default"
                              style={{
                                width: '25px',
                                height: '25px',
                                color: '#666',
                              }}
                              key={'btn' + index}
                              onClick={() => {
                                arrayHelpers.swap(index - 1, index);
                              }}
                            >
                              <i className="fa fa-exchange-alt" />
                            </button>
                          )}
                          <Field
                            name={`mainImage[2].imagesUrl[${index}]`}
                            scaleImage={true}
                            clearFormFields={[
                              `mainImage[2].imagesUrl[${index}].image`,
                            ]}
                            component={DeviceImage}
                            width={3840}
                            height={2880}
                            maxWidth={300}
                            maxHeight={(300 / 3840) * 2880}
                            values={formikProps.values}
                          />
                        </div>
                      )
                    )}
                </div>
              )}
            </FieldArray>
          )}
        </div>
      </div>
      {device.value === 'pad' && (
        <div className="form-group row">
          <label className="col-3 col-lg-5 col-md-5 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers">
              Speed of Image Rollovers
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-3' : 'col-7'}>
            <Field
              name="mainImage[0].autoplayTimeout"
              component={InputBox}
              type="number"
              postfix={
                <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers.seconds">
                  Seconds
                </Trans>
              }
            />
          </div>
        </div>
      )}
      {device.value === 'mobile' && (
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers">
              Speed of Image Rollovers
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-3' : 'col-8'}>
            <Field
              name="mainImage[1].autoplayTimeout"
              component={InputBox}
              type="number"
              postfix={
                <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers.seconds">
                  Seconds
                </Trans>
              }
            />
          </div>
        </div>
      )}
      {device.value === 'padLandscape' && (
        <div className="form-group row">
          <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
            <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers">
              Speed of Image Rollovers
            </Trans>
          </label>
          <div className={width >= 1366 ? 'col-3' : 'col-8'}>
            <Field
              name="mainImage[2].autoplayTimeout"
              component={InputBox}
              type="number"
              postfix={
                <Trans i18nKey="p.s.uiconfiguration.landingpage.speed.image.rollovers.seconds">
                  Seconds
                </Trans>
              }
            />
          </div>
        </div>
      )}
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.landingpage.language.selector">
          Language Selector
        </Trans>
        <div
          className="kt-margin-t-10 kt-margin-b-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-left">
          <Trans i18nKey="p.s.uiconfiguration.landingpage.show.language.selector">
            Show Language Selector
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="langSelector.isShow"
            value={_get(formikProps.values, 'langSelector.isShow')}
            component={CustomSwitch}
          />
        </div>
      </div>
      {_get(formikProps.values, 'langSelector.isShow') && (
        <div>
          <Field name="langSelector.options">
            {props => (
              <div className="form-group  flex__block flex__item-align-center flex__flow-wrap">
                <div className="col-md-12">
                  <ToggleEnableField
                    itemList={_get(formikProps, 'values.langSelector.options')}
                    onChange={list => {
                      const seqList = [...list];
                      props.form.setFieldValue(props.field.name, seqList);
                    }}
                    minEnable={1}
                  />
                </div>
              </div>
            )}
          </Field>
        </div>
      )}
    </>
  );
}
